import React, { ReactElement } from 'react';
import { IconButton, Typography, styled } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import history from 'services/history';

interface MakeStyleProps {
  gutterbottom: boolean;
}

const Container = styled('div')<MakeStyleProps>(props => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: props.gutterbottom ? 20 : 0,
  [props.theme.breakpoints.down('md')]: {
    paddingLeft: 0,
  },
  '@media print': {
    display: 'none',
  },
}));

const Content = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
});

const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  columnGap: 7,
  [theme.breakpoints.down('md')]: {
    paddingRight: 0,
  },
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const CustomIconButton = styled(IconButton)({
  marginRight: 15,
});

interface PageHeaderActionsProps {
  title: string;
  description?: string;
  gutterbottom?: boolean;
  ActionComponent?: ReactElement;
  backUrl?: string;
}

const PageHeaderActions: React.FC<PageHeaderActionsProps> = ({
  title,
  description,
  gutterbottom = true,
  ActionComponent,
  backUrl,
}) => {
  return (
    <Container gutterbottom={gutterbottom}>
      <Content>
        {backUrl && (
          <CustomIconButton size="small" onClick={() => history.push(backUrl)}>
            <ArrowBack />
          </CustomIconButton>
        )}
        <div>
          <Typography variant="h6">{title}</Typography>
          {description && (
            <Typography color="textSecondary" variant="body2">
              {description}
            </Typography>
          )}
        </div>
      </Content>

      {ActionComponent && <Actions>{ActionComponent}</Actions>}
    </Container>
  );
};

export default PageHeaderActions;
